<template>
  <div id="establishment-convention-modal">
    <modal v-model="show"
           :footer="false"
           :title="`SIGNATAIRES - ${surveillance.establishment.name}`">
      <div v-if="complete" class="text-justify">
        <alert type="success" >
          <h3>Charte validée !</h3>
          <p>
            <strong>
              Votre charte a été acceptée par l'équipe SPIADI et
              restera valide pour toute l'année {{ surveillance.year }}.
            </strong>
          </p>
        </alert>
        <alert type="info">
          <p>
            Les éventuelles modifications de signataires devront être uniquement reportées
            sur la charte d'engagement {{ surveillance.year + 1 }}.
          </p>
        </alert>
      </div>
      <div v-else>
        <alert type="warning" class="text-justify">
          <p>
            La charte d'engagement doit être signée par :
            <ul>
              <li>Le responsable du programme <strong>(vous)</strong></li>
              <li>
                Le directeur de l'établissement
                (<small>ou son représentant</small>)
              </li>
              <li>
                Le biologiste en charge des analyses de bactériologie pour
                l'établissement
              </li>
            </ul>
          </p>
        </alert>
      </div>
      <hr />
      <h4>
        Responsable du programme
      </h4>
      <div class="row">
        <div class="col-xs-12 col-md-6">
          <div class="form-group">
            <label class="control-label">Nom</label>
            <input required class="form-control" type="text" disabled
                   :value="registrator.name"/>
          </div>
        </div>
        <div class="col-xs-12 col-md-6">
          <div class="form-group">
            <label class="control-label">Prénom</label>
            <input required class="form-control" type="text" disabled
                   :value="registrator.firstName"/>
          </div>
        </div>
        <div class="col-xs-12" v-if="registrator.emails.length > 1">
          <div class="form-group">
            <label for="job" class="control-label">
              Adresse e-mail à utiliser pour cette charte
            </label>
            <select id="remail"
                    class="form-control"
                    :disabled="disableAllControls"
                    v-model.trim="reg.email"
                    placeholder="Adresse e-mail à utiliser sur la charte" >
              <option v-for="(e, i) in registrator.emails" :key="i">
                {{ e }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-xs-12" v-else>
          <div class="form-group">
            <label class="control-label">Adresse e-mail</label>
            <input required class="form-control" type="text" disabled
                   :value="registrator.emails[0]"/>
          </div>
        </div>
      </div>
      <hr />
      <h4>
        Directeur de l'établissement
        <small>ou son représentant</small>
      </h4>
      <div class="row">
        <div class="col-xs-12 col-md-6">
          <div class="form-group"
               :class="{ 'has-error': dir.name.error }">
            <label for="name" class="control-label">
              Nom
            </label>
            <input required
                   id="name"
                   class="form-control"
                   :disabled="disableAllControls"
                   v-model.trim="dir.name.value"
                   type="text"
                   @blur="checkName(dir)"
                   placeholder="Nom"/>
            <span class="text-danger help-block">{{ dir.name.error }}</span>
          </div>
        </div>
        <div class="col-xs-12 col-md-6">
          <div class="form-group"
               :class="{ 'has-error': dir.firstName.error }">
            <label for="firstName" class="control-label">
              Prénom
            </label>
            <input required
                   id="firstName"
                   class="form-control"
                   :disabled="disableAllControls"
                   v-model.trim="dir.firstName.value"
                   type="text"
                   @blur="checkFirstName(dir)"
                   placeholder="Prénom"/>
            <span class="text-danger help-block">{{ dir.firstName.error }}</span>
          </div>
        </div>
      </div>

      <div class="form-group"
           :class="{ 'has-error': dir.email.error }">
        <label for="job" class="control-label">
          Adresse e-mail
        </label>
        <input required
               id="email"
               class="form-control"
               :disabled="disableAllControls"
               v-model.trim="dir.email.value"
               type="text"
               @blur="checkEmail(dir)"
               placeholder="direction@chu-truc.fr ..."/>
        <span class="text-danger help-block">{{ dir.email.error }}</span>
      </div>
      <hr />
      <h4>
        Biologiste en charge de votre établissement
      </h4>
      <div class="row">
        <div class="col-xs-12 col-md-6">
          <div class="form-group"
               :class="{ 'has-error': bio.name.error }">
            <label for="name" class="control-label">
              Nom
            </label>
            <input required
                   id="name"
                   class="form-control"
                   :disabled="disableAllControls"
                   v-model.trim="bio.name.value"
                   type="text"
                   @blur="checkName(bio)"
                   placeholder="Nom"/>
            <span class="text-danger help-block">{{ bio.name.error }}</span>
          </div>
        </div>
        <div class="col-xs-12 col-md-6">
          <div class="form-group"
               :class="{ 'has-error': bio.firstName.error }">
            <label for="firstName" class="control-label">
              Prénom
            </label>
            <input required
                   id="firstName"
                   class="form-control"
                   :disabled="disableAllControls"
                   v-model.trim="bio.firstName.value"
                   type="text"
                   @blur="checkFirstName(bio)"
                   placeholder="Prénom"/>
            <span class="text-danger help-block">{{ bio.firstName.error }}</span>
          </div>
        </div>
      </div>

      <div class="form-group"
           :class="{ 'has-error': bio.email.error }">
        <label for="job" class="control-label">
          Adresse e-mail
        </label>
        <input id="email"
               class="form-control"
               :disabled="disableAllControls"
               v-model.trim="bio.email.value"
               type="text"
               @blur="checkEmail(bio)"
               placeholder="biologiste@chu-truc.fr ..."/>
        <span class="text-danger help-block">{{ bio.email.error }}</span>
      </div>
      <hr v-show="!complete" />
      <collapse v-model="error.error">
        <div class="error-collapse-content">
          <sui-error-panel :error="error">
          </sui-error-panel>
        </div>
      </collapse>
      <btn type="success" block size="lg"
           v-show="!complete"
           @click="saveMembers" :disabled="disableSave">
        Enregistrer les signataires
      </btn>
    </modal>
  </div>
</template>
<script>
import tools from '@/sui/tools/main'
import suiErrorPanel from '@/sui/components/errorpanel'
import Error from '@/sui/tools/error'

export default {
  name: 'establishment-convention-modal',
  props: {
    value: {
      type: Boolean,
      required: true
    },

    surveillance: {
      type: Object,
      required: true
    },

    complete: {
      type: Boolean,
      default: false
    }
  },

  components: {
    'sui-error-panel': suiErrorPanel
  },

  data: function () {
    return {
      show: this.value,
      error: new Error(),
      waiting: false,
      dir: {
        name: {
          value: '',
          error: ''
        },

        firstName: {
          value: '',
          error: ''
        },

        email: {
          value: '',
          error: ''
        }
      },
      bio: {
        name: {
          value: '',
          error: ''
        },

        firstName: {
          value: '',
          error: ''
        },

        email: {
          value: '',
          error: ''
        }
      },

      reg: {
        email: ''
      }
    }
  },

  watch: {
    value: function () {
      if (!this.value) {
        this.fill()
      }
      this.show = this.value
    },

    show: function () {
      this.$emit('input', this.show)
    },

    surveillance: function (s) {
      this.fill()
    }
  },

  mounted: function () {
    this.fill()
  },

  computed: {
    disableAllControls: function () {
      return this.waiting || this.complete
    },

    hasError: function () {
      return (this.dir.name.error !== '' ||
              this.dir.firstName.error !== '' ||
              this.dir.email.error !== '' ||
              this.bio.name.error !== '' ||
              this.bio.firstName.error !== '' ||
              this.bio.email.error !== '')
    },

    registrator: function () {
      return this.surveillance.registrator
    },

    registratorEmail: function () {
      if (this.registrator.emails.length === 1) {
        return this.registrator.emails[0]
      }

      return this.reg.email
    },

    memberUpdated: function () {
      const vm = this
      function compare (r, v) {
        const member = vm.surveillance.cvt[r]
        if (member == null) {
          return false
        }

        return member.name !== v.name.value ||
               member.fn !== v.firstName.value ||
               member.eml !== v.email.value
      }

      return compare('dir', this.dir) ||
             compare('bio', this.bio) ||
             this.registrator.name !== vm.surveillance.cvt.reg.name ||
             this.registrator.firstName !== vm.surveillance.cvt.reg.fn ||
             this.registratorEmail !== vm.surveillance.cvt.reg.eml
    },

    disableSave: function () {
      function incomplete (r) {
        return r.name.value === '' || r.firstName.value === '' ||
               r.email.value === ''
      }

      const i = this.hasError || this.registratorEmail === null ||
                incomplete(this.dir) || incomplete(this.bio)
      return i || !this.memberUpdated
    }

  },

  methods: {
    setNetworkError: function () {
      this.error.set(
        'Erreur inattendue !',
        `Une erreur inattendue s'est produite lors de l'enregistrement des
        signataires de la charte d'engagement.`,
        `Vérifiez votre connexion internet avant de réessayer.`
      )
    },

    setField: function (t, f, v) {
      this[t][f].value = v
      this[t][f].error = ''
    },

    setMember: function (t, n, fn, e) {
      this.setField(t, 'name', n)
      this.setField(t, 'firstName', fn)
      this.setField(t, 'email', e)
    },

    fill: function () {
      this.error.reset()
      this.reg.email = ''
      this.setMember('dir', '', '', '')
      this.setMember('bio', '', '', '')

      const s = this.surveillance
      if (s == null) {
        return
      }

      const list = ['bio', 'dir']
      const vm = this
      list.forEach(
        l => {
          const m = s.cvt[l]
          vm.setMember(l, m.name, m.fn, m.eml)
        }
      )

      if (s.cvt.reg != null && s.cvt.reg.eml !== '') {
        this.reg.email = s.cvt.reg.eml
      }
    },

    saveMembers: function () {
      const members = [
        {
          role: 2,
          name: this.dir.name.value,
          fn: this.dir.firstName.value,
          eml: this.dir.email.value
        },
        {
          role: 1,
          name: this.bio.name.value,
          fn: this.bio.firstName.value,
          eml: this.bio.email.value
        },
        {
          role: 3,
          name: this.registrator.name,
          fn: this.registrator.firstName,
          eml: this.registratorEmail
        }
      ]
      this.waiting = true
      this.$store.dispatch(
        'surveillances/updateConventionMembers',
        {
          id: this.surveillance.establishment.id,
          ups: {
            memb: members
          }
        }
      ).then(
        (r) => {
          this.waiting = false
          if (r.data.err != null) {
            this.setNetworkError()
          } else {
            this.show = false
            this.$notify(
              {
                type: 'success',
                title: 'Signataires enregistrés',
                content: `Les nouveaux signataires ont bien été enregistrés.`
              }

            )
          }
          return r
        }
      ).catch(
        (e) => {
          this.waiting = false
          this.setNetworkError()
        }
      )
    },

    checkEmpty: function (field, text) {
      if (field.value === '') {
        field.error = text
      } else {
        field.error = ''
      }
    },

    checkFirstName: function (f) {
      this.checkEmpty(f.firstName, 'Aucun prénom saisi.')
    },

    checkName: function (f) {
      this.checkEmpty(f.name, 'Aucun nom saisi.')
    },

    checkEmail: function (f) {
      this.checkEmpty(f.email, 'Aucune adresse e-mail saisie.')
      if (!tools.isEmailValid(f.email.value)) {
        f.email.error = `L'adresse e-mail saisie est invalide.`
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import '~variables';

.has-error .control-label {
  color: @brand-danger;
}

.has-error .help-block {
  color: @brand-danger;
}

.alert-success h3 {
  color: white;
}
</style>
